import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { ApiUrl } from '../conf/config';

import { ReqLogin } from '../types/api/auth';

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const history = useHistory();

  const login = useCallback((body: ReqLogin) => {
    setError(false);
    setLoading(true);

    axios
      .post(`${ApiUrl}/admin/api/v1/login`, body)
      .then((res) => {
        // tokenを保存
        sessionStorage.setItem('token', res.data.token);
        history.push('/');
      })
      .catch((error) => {
        console.error(error);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { login, loading, error };
};
